import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Core2Config } from '../../utils/core2-config';
import { ApiVisa } from '../../models/base/apivisa.model';
import { BaseService } from '../../templates/services/base-service.template';
import { getHttpHeader } from '../../utils/http-header.factory';

@Injectable({
  providedIn: 'root'
})
export class MerchantTxnReportAttachmentService implements BaseService {

  public apiUrl: string = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'pgw/txn-merchant-attachment';

  constructor(protected readonly http: HttpClient) {}

  public generateReport(summaryGuid: string, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<any>{
    return this.http.post(`${ api_domain_url }${ this.apiUrl }/generate-report/${ summaryGuid }`, {}, getHttpHeader(jwt_secret, tenantCode));
  }
}
